import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import TicketDetail from "@/pages/TicketDetail";
import Kanban from "@/pages/Kanban";
import TimeTracker from "@/pages/TimeTracker";
import Billing from "@/pages/Billing";
import Agents from "@/pages/Agents";
import EmailFeed from "@/pages/EmailFeed";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        <div className="font-mono-digits text-sm tracking-widest animate-pulse">LOADING…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="tickets/:id" element={<TicketDetail />} />
              <Route path="kanban" element={<Kanban />} />
              <Route path="time" element={<TimeTracker />} />
              <Route path="billing" element={<Billing />} />
              <Route path="agents" element={<Agents />} />
              <Route path="email-feed" element={<EmailFeed />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
